export default "__VITE_ASSET__CVXXGAsA__"